import React, { useState } from "react";
import { Box, Grid, Popover, Stack, Typography } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import PropTypes from "prop-types";
import { formatDate, formatTime } from '../../extends/NumberFormat';
const styles = {
  bold: {
    fontWeight: "bold",
  },
  headerBold: {
    fontWeight: "bold",
    textDecoration:'underline',
    cursor: "pointer"
  },
  border: {
    border: "1px solid #F6F6F9",
    borderRadius: 10,
    background: "#F6F6F9",
    padding: 13,
  },
  typography: {
    padding: 10,
    maxWidth: 400,
    maxHeight:400,
    overflowY: 'auto'
  },
};

const PopoverEventDetails = props => {
  const { classes, event } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const {name,address1,address2,city,state,postalCode} = event?.venue || {}
  const contactAddress = [name, [address1,address2].filter(Boolean).join('\n'), [city, state, postalCode].filter(Boolean).join(' ') ].filter(Boolean).filter(c => c !== 'Same As Contact').join('\n')


  
  return (
    <Grid container>
      <Grid item>
        <Typography
          aria-describedby={id}
          variant="subtitle1"
          onClick={handleClick}
          className={classes.headerBold}
        >
          {event.invoiceNumber} : {event.title}
        </Typography>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left"
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
        >
          <Box className={classes.border} m={1}>
            <Stack direction="row" gap={1} >
              <Typography variant="subtitle1">
                <span className={classes.bold}>Event Date:</span>
              </Typography>
              <Typography variant="subtitle1">
                {formatDate(event.date)}                
              </Typography>
            </Stack>
            { (event?.startTime || event?.endTime) && (
               <Stack direction="row" gap={1} >
                <Typography variant="subtitle1">
                  <span className={classes.bold}>Event Time:</span>
                </Typography>
                <Typography variant="subtitle1">
                {[event?.startTime, event?.endTime].map(t => t && t.length ? formatTime(t) : '[?]').join(' - ')}                
              </Typography>
               </Stack>
            )}
            <Stack direction="row" gap={1} >
              <Typography variant="subtitle1">
                <span className={classes.bold}>Guest Count:</span>
              </Typography>
              <Typography variant="subtitle1">
                {event.guestCount}
              </Typography>
            </Stack>
            { event.serviceStyle && event.serviceStyle.length && (
              <Stack direction="row" gap={1} >
              <Typography variant="subtitle1">
                <span className={classes.bold}>Service Style:</span>
              </Typography>
              <Typography variant="subtitle1">
                {event.serviceStyle}
              </Typography>
            </Stack>
            )}
            <Stack direction="row" gap={1} >
              <Typography variant="subtitle1">
                <span className={classes.bold}>Venue:</span>
              </Typography>
              <Typography variant="subtitle1">
                {contactAddress.split('\n').map(p => (<>{p}<br/></>))}
              </Typography>
            </Stack>
          </Box>
        </Popover>
      </Grid>
    </Grid>
  );
};

PopoverEventDetails.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withStyles(styles)(PopoverEventDetails);
